module.exports = __webpack_public_path__ + "product-stationary-availability.svg?bdc7b4a9c38c7c33484e96a37d495ddc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-stationary-availability.svg
// module id = 315
// module chunks = 2